<template>
    <div>
        <div
            id="top-bar-secondary-wrapper"
            class="top-bar-secondary"
            :class="{
                full: isSideMenuHidden,
                'hover-mode': isHoverMode,
                'render-ci': renderCI
            }"
        >
            <button
                @click="$store.commit('toggleSideMenu')"
                class="toggleSide"
                title="Toggle Side Menu"
            >
                <i
                    v-if="isSideMenuHidden"
                    class="far fa-caret-square-right"
                ></i>
                <i v-else class="far fa-caret-square-left"></i>
            </button>

            <!-- Sub menus / Module actions -->
            <div class="submenus d-none d-lg-flex" v-if="!renderCI">
                <b-navbar type="light" class="module-navbar">
                    <slot name="module-action-left" />
                    <slot name="module-action-right" />
                </b-navbar>
            </div>

            <nav-utility class="d-flex flex-grow-1 justify-content-end" />
        </div>

        <!-- Collapsed submenus / module actions on mobile & tablet view -->
        <div class="navbar-action-collapsed d-flex d-lg-none" v-if="!renderCI">
            <b-navbar type="light" class="module-navbar" toggleable>
                <b-navbar-toggle
                    target="nav_dropdown_collapse"
                ></b-navbar-toggle>
                <b-collapse id="nav_dropdown_collapse" is-nav>
                    <slot name="module-action-left"></slot>
                </b-collapse>

                <slot name="module-action-right"></slot>
            </b-navbar>
        </div>
    </div>
</template>

<script>
import NavUtility from "@/module/layout/nav-utility.vue";

export default {
    name: "TopBarSecondaryEnhanced",
    components: { NavUtility },
    props: {
        renderCI: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isSideMenuHidden() {
            return this.$store.state.isSideMenuHidden;
        },
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        },
        isHoverMode() {
            return this.$store.state.isHoverMode || false;
        }
    }
};
</script>

<style lang="scss" scoped>
$top-bar-secondary-height: 52px;
$top-bar-ci-height: 46px;

.top-bar-secondary {
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 280px;
    right: 0;
    height: $top-bar-secondary-height;
    z-index: 1001;
    background: #c9ccde;
    transition: left 0.3s ease;

    &.full {
        left: 0;
    }

    &.hover-mode {
        left: 0 !important;
    }

    &.render-ci {
        right: 0;
        height: $top-bar-ci-height;
    }

    &.render-ci.ci-hidden {
        display: none;
    }

    .submenus {
        flex-grow: 1;

        ::v-deep ul:first-of-type.navbar-nav > li > a {
            white-space: nowrap;
            display: inline-flex;
            align-items: center;
            gap: 4px;
        }
    }

    button.toggleSide {
        background: none;
        border: none;
        outline: none;
        padding: 10px;
        font-size: 1.4em;
    }
}

.navbar-action-collapsed {
    .module-navbar {
        width: 100%;
        background-color: transparent;
    }
}
</style>
